( function( global, $ ) {
    "use strict";

    var _events = {
        onChangeType: function() {
            $(this).trigger('refresh');
        },

        onRefreshType: function() {
            var $typeInput = $(this),
                $formEntry = $typeInput.closest('[data-form-entry="artistfee"]'),
                $valueField = $formEntry.find('[data-form-field="value"]'),
                $valueInput = $formEntry.find('[data-form-control="value"]'),
                $fromField = $formEntry.find('[data-form-field="from_amount"]'),
                $fromInput = $formEntry.find('[data-form-control="from_amount"]'),
                $fromFirstSoldTicketField = $formEntry.find('[data-form-field="from_first_sold_ticket"]'),
                $fromFirstSoldTicketInput = $formEntry.find('[data-form-control="from_first_sold_ticket"]'),
                $valueGroupField = $formEntry.find('[data-form-field="value_group"]'),
                $specificationField = $formEntry.find('[data-form-field="specification"]'),
                $specificationInput = $formEntry.find('[data-form-control="specification"]'),
                $labels = $valueField.find('label[data-label-value]'),
                type = $typeInput.val(),
                value = $valueInput.val(),
                labelType = '';

            $valueField.addClass('hidden');
            $fromField.addClass('hidden');
            $fromFirstSoldTicketField.addClass('hidden');
            $fromFirstSoldTicketInput.addClass('hidden');
            $specificationField.addClass('hidden');
            $valueGroupField.addClass('hidden');

            $valueInput.prop('required', false);
            $fromInput.prop('required', false);
            $specificationInput.prop('required', false);

            if (type !== '') {
                if (type === '0') {
                    labelType = 'fixed_by_representation';
                } else if (type === '1') {
                    labelType = 'percent_by_representation';

                    $valueInput.attr('max', 100);

                    if (value >= 100) {
                        $valueInput.val('');
                    }

                    $fromField.removeClass('hidden');
                } else if (type === '2') {
                    labelType = 'fixed';
                } else {
                    labelType = 'custom';
                }

                if (labelType === 'custom') {
                    $specificationField.removeClass('hidden');
                    $specificationInput.prop('required', true);
                } else {
                    $valueGroupField.removeClass('hidden');
                    $valueField.removeClass('hidden');
                    $valueInput.prop('required', true);
                }

                if (labelType === 'percent_by_representation') {
                    $fromInput.prop('required', true);
                    $fromFirstSoldTicketField.removeClass('hidden');
                    $fromFirstSoldTicketInput.removeClass('hidden');

                    if ($fromInput.val() > 0) {
                        $fromField.removeClass('hidden');
                        $fromInput.removeClass('hidden');
                        $fromFirstSoldTicketInput.prop('checked', false);
                    } else {
                        $fromField.addClass('hidden');
                        $fromInput.addClass('hidden');
                        $fromFirstSoldTicketInput.prop('checked', true);
                    }
                } else {
                    $valueInput.removeAttr('max');
                }
            }

            $labels.addClass('hidden');
            $labels.filter('[data-label-value="'+labelType+'"]').removeClass('hidden');
        },

        onChangeFirstSoldTicket : function() {
            var $fromFirstSoldTicketInput = $(this),
                $formEntry = $fromFirstSoldTicketInput.closest('[data-form-entry="artistfee"]'),
                $fromInput = $formEntry.find('[data-form-control="from_amount"]'),
                $typeInput = $formEntry.find('[data-form-control="type"]'),
                $form = $($typeInput.get(0).form),
                type = $typeInput.val(),
                showFromField = type === '1' && ! $fromFirstSoldTicketInput.prop('checked');

            $fromFirstSoldTicketInput.trigger('refresh');

            if(showFromField) {
                $fromInput.val('').focus();
            }

            $form.data('form-autosubmit', ! showFromField);
        },

        onRefreshFirstSoldTicket: function() {
            var $fromFirstSoldTicketInput = $(this),
                $formEntry = $fromFirstSoldTicketInput.closest('[data-form-entry="artistfee"]'),
                $typeInput = $formEntry.find('[data-form-control="type"]'),
                $form = $($typeInput.get(0).form),
                $fromField = $formEntry.find('[data-form-field="from_amount"]'),
                $fromInput = $formEntry.find('[data-form-control="from_amount"]'),
                type = $typeInput.val(),
                showFromField = type === '1' && ! $fromFirstSoldTicketInput.prop('checked');

            $fromField.toggleClass('hidden', ! showFromField);
            $fromInput.toggleClass('hidden', ! showFromField);

            if (! showFromField) {
                $fromInput.val('0');
            }
        },

        onChangeInput: function() {
            var $this = $(this),
                $form = $($this.get(0).form);

            if ($(this).data('form-control') !== 'from_first_sold_ticket') {
                $form.data('form-autosubmit', true);
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formInputs = $container.find('form[name="booking_artistfees_form"] :input'),
            $formEntries = $container.find('form [data-form-entry="artistfee"]'),
            $typeInputs = $formEntries.find('[data-form-control="type"]'),
            $fromFirstSoldTicketInput = $formEntries.find('[data-form-control="from_first_sold_ticket"]');

        $typeInputs
            .on('change', _events.onChangeType)
            .on('refresh', _events.onRefreshType)
            .trigger('refresh');

        $formInputs.on('change.artistfee', _events.onChangeInput);

        $fromFirstSoldTicketInput
            .on('change', _events.onChangeFirstSoldTicket)
            .on('refresh', _events.onRefreshFirstSoldTicket)
            .trigger('refresh');
    });

}( window.groots, jQuery ));
